
export const toRedirectDetailPage = (fromPage: string | undefined, jobId: any | undefined,history:any | undefined) => {
   
    let userAgent = navigator.userAgent;
    let browserName = "ABC";;
    if (userAgent.match(/firefox|fxios/i)) {
      browserName = "firefox";
    }
    if (browserName === "firefox") {
      if (fromPage === "addBtn") {
        history.go(0);
      }
      else {
        const redirectUrl = '/datascout/search-details/' + jobId;
        history.replace(redirectUrl);
  
      }
    }
    else {
      const redirectUrl = '/datascout/search-details/' + jobId;
      history.replace(redirectUrl);
      history.go(0);
    }
    return [];
  }
  